import _ from 'lodash';

export const NOTIFICATIONS_ACTIONS = {
    LOAD_NOTIFICATIONS: "LOAD_NOTIFICATIONS",
    PUSH_NOTIFICATION: "PUSH_NOTIFICATION",
    MARK_ALL_AS_READ: "MARK_ALL_AS_READ",
    MARK_SINGLE_AS_READ: "MARK_SINGLE_AS_READ",
    REMOVE_NOTIFICATIONS_BY_TYPE: "REMOVE_NOTIFICATIONS_BY_TYPE"
};

export const NOTIFICATIONS_ACTIONS_DISPATCH = _.mapValues(NOTIFICATIONS_ACTIONS, v => `notifications/${v}`);